module.exports = __webpack_public_path__ + "static/desktop/img/case6.41d00f8d.jpg";